export const insightStaticSummary = {
  'Low Oil Pressure': {
    issue: 'Low Oil Pressure',
    subsystem: 'Lubrication system (oil pump, oil passages, oil sump)',
    causes:
      'Oil leaks,<br> Worn-out engine internals,<br> Faulty oil pump or pressure sensor',
    impact: 'Can halt asset operation, reducing productivity by ~19%.',
    recommendedAction:
      'Urgent inspection for leaks, check and possibly replace oil pump/filter, and verify sensor readings.',
  },
  'Engine Overheating (Coolant)': {
    issue: 'Engine Overheating (Coolant)',
    subsystem:
      'Engine cooling system (radiator, coolant hoses, water pump), Engine block/head',
    causes:
      'Typically results from oil leaks, worn engine parts, or issues with the oil pump or sensors.',
    impact:
      'This issue can bring operations to a halt. Associated with ~27% decrease in engine hours and a 5.53% increase in fuel rate.',
    recommendedAction:
      'Conduct radiator cleaning, verify coolant levels and circulation, and validate sensor accuracy.',
  },
  'Engine Overheating (Oil)': {
    issue: 'Engine Overheating (Oil)',
    subsystem:
      'Engine lubrication system (oil pump, oil galleries), Engine oil cooler, Engine cooling system (radiator, coolant hoses, water pump)',
    causes:
      'Can result from blocked coolant lines, malfunctioning radiator, poor oil circulation, clogged filters, worn-out engine components, or failures in the cooling or temperature sensing mechanisms.',
    impact:
      'Can stop the vehicle, reduce engine hours by 27%, and increase fuel consumption by over 6%.',
    recommendedAction:
      'Inspect and clean the radiator, change the oil and filters, check coolant levels and pump operation, and verify the accuracy of related sensor data.',
  },
  'Air Filter Clogged': {
    issue: 'Air Filter Clogged',
    subsystem: 'Engine Air Filter',
    causes:
      'Dust buildup in the air filter, extended operation in dusty environments, delayed maintenance, or improper filter sealing.',
    impact:
      'Restricts airflow to the engine, causing poor combustion, ~12–18% drop in power, and ~4–6% rise in fuel consumption. May trigger false overheat or turbo alerts.',
    recommendedAction:
      'Clean or replace air filter, ensure proper fitment, verify airflow sensor readings, and increase inspection frequency for high-dust conditions.',
  },
  'Coolant Leak': {
    issue: 'Coolant Leak',
    subsystem: 'Cooling system (radiator, hoses, heater core, water pump)',
    causes:
      'Cracks in hoses or radiator, loose clamps, or defective sealing components.',
    impact:
      'Serious fault that may stop the machine. Performance impact is currently inconclusive.',
    recommendedAction:
      'Visually inspect for leaks, conduct pressure tests, and replace worn or cracked components.s',
  },
  'Dpf Regen Ineffective': {
    issue: 'DPF Regen Ineffective',
    subsystem:
      'Exhaust aftertreatment (DPF, DOC, SCR if present), Fuel injection/combustion system',
    causes:
      'Clogging in the DPF, poor combustion, or sensor-related faults in the exhaust system.',
    impact:
      'Limits vehicle operation. Productivity and fuel data is currently limited.',
    recommendedAction:
      'Initiate a forced DPF regeneration cycle, clean or replace the DPF unit, and ensure sensor accuracy.',
  },
  'Transmission Inefficiency': {
    issue: 'Transmission Inefficiency',
    subsystem:
      'Transmission system (gearbox, clutch, torque converter), drive shaft, sensors for speed and RPM',
    causes:
      'Occurs when the ratio of transmission speed to engine RPM deviates from expected thresholds, often due to worn clutch plates, degraded transmission fluid, torque converter malfunction, or sensor inaccuracies.',
    impact:
      'This issue reduces drivetrain efficiency, increases fuel consumption, and may cause transmission overheating, ultimately risking breakdown and operational downtime.',
    recommendedAction:
      'Inspect transmission fluid quality and levels, check for wear in clutch and torque converter, recalibrate relevant sensors, and conduct a thorough transmission system health check.',
  },
  'Engine Air Filter Clogging': {
    issue: 'Engine Air Filter Clogging',
    subsystem:
      'Air intake system (air filter, intake manifold, turbocharger), engine combustion chamber',
    causes:
      'Caused by dust buildup in the air filter, extended operation in dusty environments, delayed maintenance, or improper filter sealing.',
    impact:
      'Restricts airflow to the engine, causing poor combustion, ~12–18% drop in power, and ~4–6% rise in fuel consumption. May trigger false overheat or turbo alerts.',
    recommendedAction:
      'Clean or replace air filter, ensure proper fitment, verify airflow sensor readings, and increase inspection frequency for high-dust conditions.',
  },
  'Tpms Slow Leak': {
    issue: 'TPMS Slow Leak',
    subsystem: 'Wheels and Tires (Tires, Valves, Rims, TPMS Sensors)',
    causes:
      'Small punctures (nails/screws), faulty valve stems, corroded rim seats, or extreme temperature fluctuations.',
    impact:
      'Increases rolling resistance leading to ~2-3% higher fuel consumption. Causes uneven tire wear, shortening tire life by up to 25%.',
    recommendedAction:
      'Inspect tire surface for debris, check valve core tightness, and perform a soap-water test on the rim seat. Monitor pressure trends.',
  },
  'Tpms Fast Leak': {
    issue: 'TPMS Fast Leak',
    subsystem: 'Wheels and Tires (Tires, Valves, Rims, TPMS Sensors)',
    causes:
      'Significant tire puncture, sidewall damage, catastrophic valve failure, or a cracked rim.',
    impact:
      'High risk of immediate tire blowout or rim damage. Can lead to sudden loss of vehicle control and significant unplanned downtime.',
    recommendedAction:
      'Immediate stop-work order for the asset. Replace the tire or tube immediately. Inspect the rim for structural cracks before remounting.',
  },
  'Low Engine Oil Pressure': {
    issue: 'Low Engine Oil Pressure',
    subsystem: 'Engine Oil',
    causes:
      'Low oil level,<br> Worn pump or internal leaks,<br> Faulty oil pressure sensor',
    impact: 'Can lead to accelerated wear or engine shutdown.',
    recommendedAction:
      'Verify oil level and condition, inspect for leaks, and check pump and sensor per OEM procedures.',
  },
  'High Engine Oil Temperature': {
    issue: 'High Engine Oil Temperature',
    subsystem: 'Engine Oil',
    causes:
      'Overloading,<br> Cooling system faults,<br> Degraded oil or restricted flow',
    impact: 'Reduces lubrication effectiveness and risks engine damage.',
    recommendedAction:
      'Reduce load if safe, check coolant and oil cooler, change oil if degraded, and validate temperature sensors.',
  },
  'Engine Coolant Overheating': {
    issue: 'Engine Coolant Overheating',
    subsystem: 'Engine Coolant',
    causes:
      'Low coolant,<br> Thermostat or water pump faults,<br> Blocked radiator or fan issues',
    impact: 'Can cause derate, shutdown, or severe engine damage.',
    recommendedAction:
      'Allow safe cool-down, check coolant level and leaks, inspect radiator, fan, thermostat, and water pump.',
  },
  'Low Engine Coolant Temperature': {
    issue: 'Low Engine Coolant Temperature',
    subsystem: 'Engine Coolant',
    causes:
      'Stuck-open thermostat,<br> Cold ambient operation,<br> Sensor or wiring faults',
    impact: 'May reduce efficiency and increase emissions or component wear.',
    recommendedAction:
      'Verify thermostat operation, sensor readings, and coolant circulation when warm.',
  },
  'High Air Filter Restrictions': {
    issue: 'High Air Filter Restrictions',
    subsystem: 'Engine Air Filter',
    causes:
      'Loaded or clogged filter,<br> Damaged intake sealing,<br> Sensor or duct restrictions',
    impact:
      'Reduces airflow, power, and fuel economy; can stress turbo or DPF.',
    recommendedAction:
      'Inspect and service or replace the air filter, check intake sealing, and validate restriction indicators.',
  },
  'Low Turbo Boost Pressure': {
    issue: 'Low Turbo Boost Pressure',
    subsystem: 'Engine -Air Intake and Turbo Charger',
    causes:
      'Intake leaks,<br> Turbo or wastegate faults,<br> Sensor or charge air cooler issues',
    impact: 'Loss of power and poor fuel efficiency.',
    recommendedAction:
      'Inspect charge air path for leaks, check turbo and wastegate, and verify boost sensor readings.',
  },
  'High Turbo Boost Pressure': {
    issue: 'High Turbo Boost Pressure',
    subsystem: 'Engine -Air Intake and Turbo Charger',
    causes:
      'Overboost,<br> Wastegate or actuator faults,<br> Sensor or ECM calibration issues',
    impact: 'Risk of overstress on engine and turbo components.',
    recommendedAction:
      'Inspect wastegate and boost control, check for sensor faults, and follow OEM diagnostic steps.',
  },
  'High Crankcase Pressure': {
    issue: 'High Crankcase Pressure',
    subsystem: 'Engine -Air Intake and Turbo Charger',
    causes:
      'Blow-by,<br> Clogged crankcase ventilation,<br> Turbo seal or piston ring issues',
    impact: 'May indicate internal wear or seal failure and oil consumption.',
    recommendedAction:
      'Inspect crankcase ventilation, check for oil leaks and consumption, and assess turbo and engine health.',
  },
  'Tranmission Overheating': {
    issue: 'Tranmission Overheating',
    subsystem: 'Transmission',
    causes:
      'Low or degraded fluid,<br> Heavy load or towing,<br> Cooler or cooling line faults',
    impact: 'Can damage clutches and internal components and cause downtime.',
    recommendedAction:
      'Reduce load if safe, check fluid level and condition, inspect cooler lines, and service per OEM.',
  },
  'Transmission Oil Temperature Increasing': {
    issue: 'Transmission Oil Temperature Increasing',
    subsystem: 'Brakes',
    causes:
      'Rising fluid temperature trend,<br> Duty cycle or cooling limits,<br> Sensor or wiring drift',
    impact:
      'Sustained high temperature can damage fluid and nearby components.',
    recommendedAction:
      'Correlate with load and cooling, verify fluid condition and sensor readings, and follow OEM diagnostics.',
  },
  'Overheated Wheel - High Left Front Brake Oil Temperatue': {
    issue: 'Overheated Wheel - High Left Front Brake Oil Temperatue',
    subsystem: 'Brakes',
    causes:
      'Dragging brake,<br> Contaminated or low brake fluid,<br> Caliper or hose restriction',
    impact: 'Brake fade, wheel-end damage, or fire risk.',
    recommendedAction:
      'Inspect left front brake assembly, fluid, and lines; release drag and repair per OEM.',
  },
  'Overheated Wheel - High Right Front Brake Oil Temperatue': {
    issue: 'Overheated Wheel - High Right Front Brake Oil Temperatue',
    subsystem: 'Brakes',
    causes:
      'Dragging brake,<br> Contaminated or low brake fluid,<br> Caliper or hose restriction',
    impact: 'Brake fade, wheel-end damage, or fire risk.',
    recommendedAction:
      'Inspect right front brake assembly, fluid, and lines; release drag and repair per OEM.',
  },
  'Overheated Wheel - High Left Rear Brake Oil Temperatue': {
    issue: 'Overheated Wheel - High Left Rear Brake Oil Temperatue',
    subsystem: 'Brakes',
    causes:
      'Dragging brake,<br> Contaminated or low brake fluid,<br> Caliper or hose restriction',
    impact: 'Brake fade, wheel-end damage, or fire risk.',
    recommendedAction:
      'Inspect left rear brake assembly, fluid, and lines; release drag and repair per OEM.',
  },
  'Overheated Wheel - High Right Rear Brake Oil Temperatue': {
    issue: 'Overheated Wheel - High Right Rear Brake Oil Temperatue',
    subsystem: 'Brakes',
    causes:
      'Dragging brake,<br> Contaminated or low brake fluid,<br> Caliper or hose restriction',
    impact: 'Brake fade, wheel-end damage, or fire risk.',
    recommendedAction:
      'Inspect right rear brake assembly, fluid, and lines; release drag and repair per OEM.',
  },
  'High Hydraulic Temperature': {
    issue: 'High Hydraulic Temperature',
    subsystem: 'Hydraulic System',
    causes:
      'Low fluid,<br> Blocked cooler or restricted flow,<br> Overload or stuck valves',
    impact: 'Reduced efficiency and risk of seal or pump damage.',
    recommendedAction:
      'Check fluid level and condition, inspect cooler and filters, and reduce load until temperatures normalize.',
  },
  'Low Battery Voltage': {
    issue: 'Low Battery Voltage',
    subsystem: 'Battery',
    causes:
      'Discharged battery,<br> Alternator or charging faults,<br> Parasitic draw',
    impact: 'Starting and electronics reliability issues.',
    recommendedAction:
      'Test battery and charging system, inspect connections, and repair faults per electrical diagnostics.',
  },
  'High Battery Voltage': {
    issue: 'High Battery Voltage',
    subsystem: 'Battery',
    causes:
      'Regulator or alternator overcharge,<br> Incorrect battery type,<br> Wiring faults',
    impact: 'Risk of battery damage or electrical component stress.',
    recommendedAction:
      'Verify charging voltage, inspect alternator and regulator, and correct per OEM electrical specs.',
  },
  'Lubrication cycle locked': {
    issue: 'Lubrication cycle locked',
    subsystem: 'Lubrication',
    causes:
      'Control or interlock state,<br> Fault codes,<br> Sensor or pump logic',
    impact: 'Automated lubrication may not run as scheduled.',
    recommendedAction:
      'Clear faults, verify interlocks and sensors, and reset or service the lubrication controller per OEM.',
  },
  'Insufficient lubrication': {
    issue: 'Insufficient lubrication',
    subsystem: 'Lubrication',
    causes:
      'Low supply,<br> Blocked lines or fittings,<br> Timer or pump delivery issues',
    impact: 'Accelerated wear on pins, bushings, and bearings.',
    recommendedAction:
      'Inspect reservoirs, lines, and metering devices; prime system and restore delivery per OEM.',
  },
  'High lubrication demand with low oil': {
    issue: 'High lubrication demand with low oil',
    subsystem: 'Lubrication',
    causes:
      'High consumption points,<br> Low reservoir level,<br> Leaks or over-pumping',
    impact: 'Starved points and increased component wear.',
    recommendedAction:
      'Top up approved lubricant, find and fix leaks, and balance pump or cycle settings.',
  },
  'Reduced lubrication with low oil': {
    issue: 'Reduced lubrication with low oil',
    subsystem: 'Lubrication',
    causes:
      'Low reservoir,<br> Pump protection limiting output,<br> Air in lines',
    impact: 'Inadequate film on critical wear surfaces.',
    recommendedAction:
      'Restore oil level, bleed air if needed, and verify pump output and low-level protection.',
  },
  'Manual operation without lubrication': {
    issue: 'Manual operation without lubrication',
    subsystem: 'Lubrication',
    causes:
      'Operator bypass,<br> Disabled auto cycle,<br> Empty or failed system',
    impact: 'Missed greasing cycles and premature wear.',
    recommendedAction:
      'Ensure auto mode when appropriate, refill system, and train operators on proper use.',
  },
  'Lubrication mode not operational': {
    issue: 'Lubrication mode not operational',
    subsystem: 'Lubrication',
    causes:
      'Fault state,<br> Power or communication loss,<br> Configuration error',
    impact: 'Lubrication system may not run until cleared.',
    recommendedAction:
      'Diagnose fault codes, verify power and harnesses, and restore operational mode per OEM.',
  },
  'Lubrication halted due to pump error': {
    issue: 'Lubrication halted due to pump error',
    subsystem: 'Lubrication',
    causes:
      'Pump motor or driver fault,<br> Overcurrent,<br> Mechanical pump failure',
    impact: 'No delivery until pump fault is resolved.',
    recommendedAction:
      'Inspect pump, wiring, and fuses; repair or replace pump per OEM procedures.',
  },
  'Lubricaltion Pump disabled when low oil': {
    issue: 'Lubricaltion Pump disabled when low oil',
    subsystem: 'Lubrication',
    causes:
      'Low-level interlock,<br> Sensor fault,<br> Intentional disable for safety',
    impact: 'Pump will not run until level is restored or interlock clears.',
    recommendedAction:
      'Refill to correct level, verify level sensor, and clear interlocks when safe.',
  },
  'Low Lubrication Oil In reservior': {
    issue: 'Low Lubrication Oil In reservior',
    subsystem: 'Lubrication',
    causes: 'Consumption,<br> Leaks,<br> Underfilled reservoir',
    impact: 'Risk of pump cavitation and insufficient greasing.',
    recommendedAction:
      'Refill with specified lubricant, inspect for leaks, and set correct fill level.',
  },
  'Pump Enabled without confirmed Oil Level': {
    issue: 'Pump Enabled without confirmed Oil Level',
    subsystem: 'Lubrication',
    causes: 'Sensor not confirming level,<br> Wiring fault,<br> Logic override',
    impact: 'May run dry or overfill if level is unknown.',
    recommendedAction:
      'Confirm physical level, calibrate or replace level sensor, and align control logic.',
  },
  'Pump running but lubrication cycle paused': {
    issue: 'Pump running but lubrication cycle paused',
    subsystem: 'Lubrication',
    causes:
      'Cycle timer or valve state,<br> Blockage downstream,<br> Control software hold',
    impact: 'Points may not receive grease despite pump activity.',
    recommendedAction:
      'Check cycle parameters, distribution valves, and blockages; resume cycles per OEM.',
  },
  'Lubrication cycle error while pump is running': {
    issue: 'Lubrication cycle error while pump is running',
    subsystem: 'Lubrication',
    causes:
      'Valve or line fault,<br> Pressure anomaly,<br> Encoder or feedback error',
    impact: 'Incomplete or uneven distribution.',
    recommendedAction:
      'Review fault codes, verify line pressure and valve operation, and clear errors after repair.',
  },
  'Lubrication Pump Locked': {
    issue: 'Lubrication Pump Locked',
    subsystem: 'Lubrication',
    causes: 'Software lockout,<br> Mechanical jam,<br> Repeated fault latch',
    impact: 'No lubrication delivery until lock is cleared.',
    recommendedAction:
      'Identify lock cause, clear faults safely, and service pump or controller as required.',
  },
};

export const defaultSummary = {
  issue:
    'Diesel Particulate Filter (DPF) plugging in dump trucks causes reduced performance, higher fuel use, and potential engine damage due to soot and ash buildup.',
  causes:
    'Excessive idling, low exhaust temperature, poor fuel combustion Ash accumulation from oil, faulty sensors, or EGR issues',
  preventive:
    'Reduce idling, use low-ash oil, maintain injectors, and ensure proper fuel-air mix',
  maintenance:
    'Perform manual regeneration, clean/replace DPF, check EGR and exhaust components.',
  monitoring:
    'Use telematics for alerts, train operators to recognize early signs.',
  impact:
    'Restricts airflow to the engine, causing poor combustion, ~12–18% drop in power, and ~4–6% rise in fuel consumption. May trigger false overheat or turbo alerts.',
  recommendedAction:
    'Preventive: Reduce idling, use low-ash oil, maintain injectors, and ensure proper fuel-air mix' +
    '<br>Maintenance: Perform manual regeneration, clean/replace DPF, check EGR and exhaust components.' +
    '<br>Monitoring: Use telematics for alerts, train operators to recognize early signs.',
};

const createTimestamp = (year: number, month: number, day: number) => {
  return new Date(year, month - 1, day).getTime();
};

export const evidenceData = {
  'Slow Leak': [
    {
      sensor: 'InspectAppDetect',
      date: createTimestamp(2025, 1, 6),
      size: 5,
    },
    {
      sensor: 'InspectAppDetect',
      date: createTimestamp(2025, 1, 7),
      size: 5,
    },
    {
      sensor: 'InspectAppDetect',
      date: createTimestamp(2025, 1, 8),
      size: 5,
    },
    {
      sensor: 'InspectAppDetect',
      date: createTimestamp(2025, 1, 9),
      size: 5,
    },
    {
      sensor: 'InspectAppDetect',
      date: createTimestamp(2025, 1, 10),
      size: 5,
    },
    {
      sensor: 'InspectAppDetect',
      date: createTimestamp(2025, 1, 13),
      size: 5,
    },
    {
      sensor: 'FrontRightTire',
      date: createTimestamp(2025, 1, 6),
      size: 5,
    },
    {
      sensor: 'FrontRightTire',
      date: createTimestamp(2025, 1, 7),
      size: 5,
    },
    {
      sensor: 'FrontRightTire',
      date: createTimestamp(2025, 1, 8),
      size: 5,
    },
    {
      sensor: 'FrontRightTire',
      date: createTimestamp(2025, 1, 9),
      size: 5,
    },
    {
      sensor: 'FrontRightTire',
      date: createTimestamp(2025, 1, 10),
      size: 5,
    },
    {
      sensor: 'FrontRightTire',
      date: createTimestamp(2025, 1, 11),
      size: 5,
    },
    {
      sensor: 'FrontRightTire',
      date: createTimestamp(2025, 1, 12),
      size: 5,
    },
    {
      sensor: 'FrontRightTire',
      date: createTimestamp(2025, 1, 13),
      size: 5,
    },
  ],
};

export const defaultEvidenceData = [
  {
    sensor: 'AftertreatmentDieselExhaustFluidTankTemp',
    date: createTimestamp(2025, 1, 1),
    size: 5,
  },
  {
    sensor: 'AftertreatmentDieselExhaustFluidTankTemp',
    date: createTimestamp(2025, 1, 15),
    size: 5,
  },
  {
    sensor: 'AftertreatmentDieselExhaustFluidTankTemp',
    date: createTimestamp(2025, 1, 1),
    size: 5,
  },
  {
    sensor: 'AftertreatmentDieselExhaustFluidTankHeater',
    date: createTimestamp(2024, 12, 15),
    size: 5,
  },
  {
    sensor: 'AftertreatmentSCROperationInducementSev',
    date: createTimestamp(2024, 9, 1),
    size: 5,
  },
  {
    sensor: 'AftertreatmentSCROperationInducementSev',
    date: createTimestamp(2024, 8, 1),
    size: 5,
  },
  {
    sensor: 'AftertreatmentSCROperationInducementSev',
    date: createTimestamp(2024, 10, 1),
    size: 5,
  },
  {
    sensor: 'EngineFilteredFuelDeliveryAbsolutePressure',
    date: createTimestamp(2024, 8, 15),
    size: 5,
  },
  {
    sensor: 'EngineFilteredFuelDeliveryAbsolutePressure',
    date: createTimestamp(2024, 9, 20),
    size: 5,
  },
  {
    sensor: 'AftertreatmentDieselExhaustFluidDoserAbsol',
    date: createTimestamp(2024, 9, 25),
    size: 5,
  },
  {
    sensor: 'AftertreatmentDieselExhaustFluidDoserAbsol',
    date: createTimestamp(2024, 10, 10),
    size: 5,
  },
  {
    sensor: 'AftertreatmentDPFDifferentialPressure',
    date: createTimestamp(2024, 11, 27),
    size: 5,
  },
  {
    sensor: 'AftertreatmentDPFDifferentialPressure',
    date: createTimestamp(2024, 10, 20),
    size: 5,
  },
  {
    sensor: 'DPFConditionsNotMetForActiveRegeneration',
    date: createTimestamp(2024, 9, 20),
    size: 5,
  },
  {
    sensor: 'DPFConditionsNotMetForActiveRegeneration',
    date: createTimestamp(2024, 10, 30),
    size: 5,
  },
  {
    sensor: 'DPFConditionsNotMetForActiveRegeneration',
    date: createTimestamp(2024, 11, 30),
    size: 5,
  },
  {
    sensor: 'DPFConditionsNotMetForActiveRegeneration',
    date: createTimestamp(2024, 9, 1),
    size: 5,
  },
  {
    sensor: 'DPFConditionsNotMetForActiveRegeneration',
    date: createTimestamp(2024, 9, 10),
    size: 5,
  },
  {
    sensor: 'DPFConditionsNotMetForActiveRegeneration',
    date: createTimestamp(2024, 9, 20),
    size: 5,
  },
  {
    sensor: 'DPFConditionsNotMetForActiveRegeneration',
    date: createTimestamp(2024, 10, 31),
    size: 5,
  },
  {
    sensor: 'DPFConditionsNotMetForActiveRegeneration',
    date: createTimestamp(2024, 11, 31),
    size: 5,
  },
  {
    sensor: 'DPFConditionsNotMetForActiveRegeneration',
    date: createTimestamp(2024, 12, 31),
    size: 5,
  },
  {
    sensor: 'DPFSootLoadPercent',
    date: createTimestamp(2024, 12, 5),
    size: 5,
  },
  {
    sensor: 'AftertreatmentDieselExhaustFluidTankLevel',
    date: createTimestamp(2024, 8, 15),
    size: 5,
  },
  {
    sensor: 'AftertreatmentDieselExhaustFluidTankLevel',
    date: createTimestamp(2024, 9, 15),
    size: 5,
  },
  {
    sensor: 'AftertreatmentDieselExhaustFluidTankLevel',
    date: createTimestamp(2024, 10, 15),
    size: 5,
  },
  {
    sensor: 'InspectAppDetect',
    date: createTimestamp(2024, 8, 16),
    size: 5,
  },
];

export const sensorsData = {
  'Slow Leak': [
    'InspectAppDetect',
    'FrontLeftTire',
    'FrontRightTire',
    'RearOutsideLeftTire',
    'RearOutsideRightTire',
    'RearInsideLeftTire',
    'RearInsideRightTire',
  ],
};

export const defaultSensors = [
  'AftertreatmentDieselExhaustFluidTankTemp',
  'AftertreatmentDieselExhaustFluidTankHeater',
  'AftertreatmentSCROperationInducementSev',
  'EngineFilteredFuelDeliveryAbsolutePressure',
  'AftertreatmentDieselExhaustFluidDoserAbsol',
  'AftertreatmentDPFDifferentialPressure',
  'DPFConditionsNotMetForActiveRegeneration',
  'DPFSootLoadPercent',
  'AftertreatmentDieselExhaustFluidTankLevel',
  'InspectAppDetect',
];

export const placeholderTagValues = [
  {
    hourly: [],
    daily: [
      {
        device_sensor: 'symbotE400504-cdl_engine_oil_pressure_gauge',
        ts: 1744588800000,
        avg_val: 507.69329896907215,
        max_val: 896.5,
        min_val: 0,
        stddev_val: 296.71346588197264,
        value: 507.69329896907215,
      },
      {
        device_sensor: 'symbotE400504-cdl_engine_oil_pressure_gauge',
        ts: 1744675200000,
        avg_val: 446.08940397350995,
        max_val: 896.5,
        min_val: 0,
        stddev_val: 311.4570547501571,
        value: 446.08940397350995,
      },
      {
        device_sensor: 'symbotE400504-cdl_engine_oil_pressure_gauge',
        ts: 1744761600000,
        avg_val: 441.2857142857143,
        max_val: 896.5,
        min_val: 0,
        stddev_val: 320.1210972165328,
        value: 441.2857142857143,
      },
      {
        device_sensor: 'symbotE400504-cdl_engine_oil_pressure_gauge',
        ts: 1744848000000,
        avg_val: 519.3765432098766,
        max_val: 896.5,
        min_val: 0,
        stddev_val: 320.13574887417843,
        value: 519.3765432098766,
      },
      {
        device_sensor: 'symbotE400504-cdl_engine_oil_pressure_gauge',
        ts: 1744934400000,
        avg_val: 502.0568181818182,
        max_val: 896.5,
        min_val: 0,
        stddev_val: 310.7469350679544,
        value: 502.0568181818182,
      },
      {
        ts: 1745020800000,
        avg_val: 'NODATA',
        max_val: 'NODATA',
        min_val: 'NODATA',
        device_sensor: 'symbotE400504-cdl_engine_oil_pressure_gauge',
        stddev_val: 'NODATA',
        value: 'NODATA',
      },
      {
        device_sensor: 'symbotE400504-cdl_engine_oil_pressure_gauge',
        ts: 1745107200000,
        avg_val: 551.1287878787879,
        max_val: 896.5,
        min_val: 0,
        stddev_val: 287.60531596945975,
        value: 551.1287878787879,
      },
      {
        device_sensor: 'symbotE400504-cdl_engine_oil_pressure_gauge',
        ts: 1745193600000,
        avg_val: 445.7480916030534,
        max_val: 896.5,
        min_val: 0,
        stddev_val: 327.1567512679146,
        value: 445.7480916030534,
      },
      {
        device_sensor: 'symbotE400504-cdl_engine_oil_pressure_gauge',
        ts: 1745280000000,
        avg_val: 534.9395161290323,
        max_val: 896.5,
        min_val: 0,
        stddev_val: 317.4210457668157,
        value: 534.9395161290323,
      },
      {
        device_sensor: 'symbotE400504-cdl_engine_oil_pressure_gauge',
        ts: 1745366400000,
        avg_val: 500.9367088607595,
        max_val: 896.5,
        min_val: 0,
        stddev_val: 309.0022093698827,
        value: 500.9367088607595,
      },
      {
        device_sensor: 'symbotE400504-cdl_engine_oil_pressure_gauge',
        ts: 1745452800000,
        avg_val: 459.9867256637168,
        max_val: 896.5,
        min_val: 0,
        stddev_val: 325.7829200294776,
        value: 459.9867256637168,
      },
      {
        device_sensor: 'symbotE400504-cdl_engine_oil_pressure_gauge',
        ts: 1745539200000,
        avg_val: 460.1039603960396,
        max_val: 896.5,
        min_val: 0,
        stddev_val: 328.4756027228787,
        value: 460.1039603960396,
      },
      {
        device_sensor: 'symbotE400504-cdl_engine_oil_pressure_gauge',
        ts: 1745625600000,
        avg_val: 447.08181818181816,
        max_val: 896.5,
        min_val: 0,
        stddev_val: 331.37626543391616,
        value: 447.08181818181816,
      },
      {
        device_sensor: 'symbotE400504-cdl_engine_oil_pressure_gauge',
        ts: 1745712000000,
        avg_val: 413.17424242424244,
        max_val: 896.5,
        min_val: 0,
        stddev_val: 304.4730061601299,
        value: 413.17424242424244,
      },
      {
        device_sensor: 'symbotE400504-cdl_engine_oil_pressure_gauge',
        ts: 1745798400000,
        avg_val: 459.5684210526316,
        max_val: 896.5,
        min_val: 0,
        stddev_val: 334.30110973624465,
        value: 459.5684210526316,
      },
      {
        device_sensor: 'symbotE400504-cdl_engine_oil_pressure_gauge',
        ts: 1745884800000,
        avg_val: 447.3424657534247,
        max_val: 896.5,
        min_val: 0,
        stddev_val: 321.6203860997414,
        value: 447.3424657534247,
      },
      {
        device_sensor: 'symbotE400504-cdl_engine_oil_pressure_gauge',
        ts: 1745971200000,
        avg_val: 457.64356435643566,
        max_val: 896.5,
        min_val: 0,
        stddev_val: 311.15510872098554,
        value: 457.64356435643566,
      },
      {
        device_sensor: 'symbotE400504-cdl_engine_oil_pressure_gauge',
        ts: 1746057600000,
        avg_val: 441.7692307692308,
        max_val: 896.5,
        min_val: 0,
        stddev_val: 332.3279446879435,
        value: 441.7692307692308,
      },
      {
        device_sensor: 'symbotE400504-cdl_engine_oil_pressure_gauge',
        ts: 1746144000000,
        avg_val: 483.7945205479452,
        max_val: 896.5,
        min_val: 0,
        stddev_val: 308.3739594363433,
        value: 483.7945205479452,
      },
      {
        device_sensor: 'symbotE400504-cdl_engine_oil_pressure_gauge',
        ts: 1746230400000,
        avg_val: 477.316384180791,
        max_val: 896.5,
        min_val: 0,
        stddev_val: 304.6518857506006,
        value: 477.316384180791,
      },
      {
        device_sensor: 'symbotE400504-cdl_engine_oil_pressure_gauge',
        ts: 1746316800000,
        avg_val: 402.015625,
        max_val: 896,
        min_val: 0,
        stddev_val: 325.6414545091599,
        value: 402.015625,
      },
      {
        device_sensor: 'symbotE400504-cdl_engine_oil_pressure_gauge',
        ts: 1746403200000,
        avg_val: 453.33812949640287,
        max_val: 896.5,
        min_val: 0,
        stddev_val: 306.0437842587763,
        value: 453.33812949640287,
      },
      {
        device_sensor: 'symbotE400504-cdl_engine_oil_pressure_gauge',
        ts: 1746489600000,
        avg_val: 457.5860655737705,
        max_val: 896.5,
        min_val: 0,
        stddev_val: 321.61408328081285,
        value: 457.5860655737705,
      },
      {
        device_sensor: 'symbotE400504-cdl_engine_oil_pressure_gauge',
        ts: 1746576000000,
        avg_val: 461.5168776371308,
        max_val: 896.5,
        min_val: 0,
        stddev_val: 325.18800580697626,
        value: 461.5168776371308,
      },
      {
        device_sensor: 'symbotE400504-cdl_engine_oil_pressure_gauge',
        ts: 1746662400000,
        avg_val: 415.7469879518072,
        max_val: 896.5,
        min_val: 0,
        stddev_val: 330.3384524585213,
        value: 415.7469879518072,
      },
      {
        device_sensor: 'symbotE400504-cdl_engine_oil_pressure_gauge',
        ts: 1746748800000,
        avg_val: 0.5,
        max_val: 0.5,
        min_val: 0.5,
        stddev_val: '',
        value: 0.5,
      },
    ],
  },
];

export const normalizeTagName = (
  tagName: string,
  isSuffix: boolean = false
): string => {
  return isSuffix ? tagName.split('_')[0] : tagName.replace(/_/g, '');
};

/** True when the insight is resolved (switch ON / right). Matches table "Solved" filter. */
export const isInsightMarkedResolved = (
  resolution?: string | null,
  status?: string | null
): boolean => {
  const r = resolution ?? status;
  return r === 'Inactive' || r === 'Resolved';
};
